import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import { TYPES } from 'constants/config';
import { withTooltip } from 'components/shared/Tooltip.jsx';
import { modeSelectors } from 'selectors/pathBuilder';
import Options from './Options';
import DueDateBadge from './DueDateBadge';
import ContentTitle from './ContentTitle';
import EstimatedLessonCompletionTime from './EstimatedLessonCompletionTime';

const renderEditingButtons = ({ onCancel, onSave, savingDisabled }) => [
  <button
    type="button"
    className="u-linkBtn u-linkBtn--dark td-u"
    children="Cancel"
    key="cancel"
    onClick={onCancel}
  />,
  <button
    type="button"
    className="NewButton NewButton--blue NewButton--wide ml-16"
    disabled={savingDisabled}
    onClick={onSave}
    key="done"
    children="Done"
  />,
];

const ContentHeader = ({
  type,
  urls,
  title,
  options,
  editingMode,
  isEditing,
  onSave,
  onCancel,
  dueIn,
  savingDisabled,
  toggleEditingDueDate,
  parent,
  estimatedMinutesToComplete,
  meta,
  certification,
}) => {
  const isALesson = type === TYPES.LESSON;

  const showAddDueDate = isALesson;

  const showEstimatedLessonCompletionTime =
    editingMode && isALesson && estimatedMinutesToComplete;

  const showLessonOverviewLink = editingMode && isALesson;

  return (
    <div className="PathContent-header ai-fs">
      <ContentTitle
        {...{
          parent,
          title,
          type,
          showLessonOverviewLink,
          urls,
          badge: certification || (meta && meta.certification),
        }}
      />
      <div className="ml-16 d-f ai-c mt-4">
        {showEstimatedLessonCompletionTime && (
          <EstimatedLessonCompletionTime
            estimatedMinutesToComplete={estimatedMinutesToComplete}
            additionalStyle="mr-8"
          />
        )}
        {!isEditing && dueIn && <DueDateBadge {...dueIn} />}
        {isEditing &&
          renderEditingButtons({ onSave, onCancel, savingDisabled })}
        {editingMode &&
          !dueIn &&
          !isEditing &&
          showAddDueDate &&
          withTooltip({ text: 'Add Due Date', className: 'fz-base' })(
            <Icon
              name="calendar_add"
              className="fz-20 c-brand-gray h-c-gray-darker c-p ml-8"
              onClick={toggleEditingDueDate}
            />,
          )}
        {editingMode && !isEditing && options && <Options options={options} />}
      </div>
    </div>
  );
};

const mapStateToProps = ({ pathBuilder }) => ({
  editingMode: modeSelectors.isEdit(pathBuilder),
});

export default connect(mapStateToProps)(ContentHeader);
